<template>
  <div>
    <h3>Have you ever been told that you have diabetes (either type 1 or type 2) or are pre-diabetic?</h3>
    <p>Note: For females, please answer “No” if you have had gestational diabetes only.</p>
    <v-form-group class="card-selector" :validator="$v.diabetic">
      <b-form-checkbox v-model="survey.diabetic.isPrediabetic" @change="(value) => setOptions(value, survey.diabetic.isDiabetic, false)">Yes, I have been told that I am pre-diabetic</b-form-checkbox>
      <b-form-checkbox v-model="survey.diabetic.isDiabetic" @change="(value) => setOptions(survey.diabetic.isPrediabetic, value, false)">Yes, I have been told that I have diabetes</b-form-checkbox>
      <b-form-checkbox v-model="survey.diabetic.isNeverTold" @change="(value) => setOptions(false, false, value)">No</b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      diabetic: {
        anyOptionRequired: anyOptionRequired((value) => value.isPrediabetic || value.isDiabetic || value.isNeverTold)
      }
    },

    computed: {
      ...mapState(["survey"]),

      diabetic() { return this.survey.diabetic }
    },

    methods: {
      onSubmit() {

      },

      setOptions(isPrediabetic, isDiabetic, isNeverTold) {
        this.survey.diabetic.isPrediabetic = isPrediabetic;
        this.survey.diabetic.isDiabetic = isDiabetic;
        this.survey.diabetic.isNeverTold = isNeverTold;
      }
    }
  };
</script>